import React, { Component } from 'react';
import ScrollFadeIn from "./../../components/scrollFadeIn";
import {Helmet} from "react-helmet";

export default class BlogDetail extends Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>{'Kat Medina Blog | Articles | Observations'}</title>
          <meta name="description" content="How to avoid COVID-19 cabin fever article by Kat Medina, author of the book, The Joys of Jet Lag. How to avoid going stir crazy or getting cabin fever while you are working from home, in self-quarantine, or shelter in place because of coronavirus." />
        </Helmet>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Picture this. You are several days into your self-quarantine/WFH/shelter in place order. You’ve managed to be fairly productive working remotely and have only slipped up and had Oreos for lunch twice so far. But in light of the ever-changing developments with the coronavirus, the situation has taken a turn.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Schools have closed. Employees at non-essential jobs now must stay home. Maybe you have a significant other and/or kids that you will be sharing your cozy haven with. That changes things entirely.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Sure, it might seem like a fun adventure at first. You spice it up by wearing pajamas together as you work from the couch and relish the extra time you’ve gained by no longer having a commute.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'But on day 5, you start to notice things. Observations that only come to one’s attention after a couple of days in close quarters. Dirty socks left on the bedroom floor. The decibel at which your spouse breathes. Dishes left in the sink. The intolerable noise your child emits while open mouth chewing a banana for breakfast. Restlessness starts to set in.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Are you destined for a modern-day re-enactment of The Shining?'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Not necessarily. Redrum and damage to your bathroom door can, fortunately, be avoided.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Here are some killer suggestions for how to overcome the stir-crazy cabin fever that inevitably occurs when we spend too much time trapped inside, especially with those we love.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <h4 className="tiny-padding">{'Learn something new'}
          </h4>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'If there is a good time to be quarantined to your home, it’s now. Rather than being crammed into a one-room shack with your 15 siblings fearing a bubonic rat during a time without the internet, you have access to free education and entertainment at the click of a mouse. Instead of turning your mind into mush by binge-watching your way into oblivion or developing calluses from hourly visits to Pornhub, take advantage of your time and learn something new. '}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'You can learn pretty much ANYTHING online right now by watching YouTube videos, TED talks, or through online education platforms like Udemy, Khan Academy, Coursera, etc. Now, I’m not saying you need to give up watching cat videos altogether. Just try to find a balance between working your noggin and relaxing it.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <h4 className="tiny-padding">{'Stick to a schedule'}
          </h4>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Just because you are free to wear your faded gray, baggy-butt sweatpants doesn’t mean you have permission to throw clocks and calendars in a burn pile and light a match. Stick to a routine that involves getting up at the same time, exercising, showering, and eating at regular hours. Make a to-do list the night before and tackle the highest priority item first. If you keep putting off the most important thing, your relaxation time will be clouded with procrastination anxiety.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <h4 className="tiny-padding">{'Create'}
          </h4>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Since you no longer have to deal with your soul-crushing commute you should now have a little bit of extra time. Don’t waste it just drooling on your pillow a little longer each morning. Use this time to be creative and make something. Write, draw, play an instrument, dance, paint. Or more simply put...Play!! Do things without any other purpose than to have some fun. Bonus points if you can figure out how to have fun without the assistance of your smartphone or Hulu playlist.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <h4 className="tiny-padding">{'Clean your nasty ass house'}
          </h4>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Watch Tidying Up with Marie Kondo on Netflix and kickstart a clean sesh. Just one episode will leave you itching to get organized and inspire you to finally donate the extra Zoodler you’ve held onto for three years ‘just in case.’'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <h4 className="tiny-padding">{'Set goals'}
          </h4>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'It’s been a couple of months since you set your New Year’s resolutions, and if you’re like most people, you’ve comfortably placed them aside so they can be ignored until next December. Use your quarantine time to make a Goals & Dreams Master List. Write down everything you hope to do, learn, be, and have over the next 1, 3, 5, 10, and 20 years. Don’t hold yourself back. If you notice your mind start to scoff at your seemingly impossible dreams, tell it to politely fuck off, and go bigger.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'After completing your Master List, note all of the 1-year goals/dreams and rewrite them on a separate page to keep by your nightstand. Pick out the top three 1-year goals and think of three action items you can take to make progress on each of those. Then, remove your thumb from your bum, and take action.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <h4 className="tiny-padding">{'Exercise'}
          </h4>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'If you are in an area where you are allowed to go outside as long as you practice social distancing, go on a walk. Get outside. Being cooped up for too long makes your house smell weird and in order to get those mood-boosting endorphins that will keep you sane, you have to move. If you can’t go outside, open your windows and check out the countless free at-home workout videos available on YouTube.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <h4 className="tiny-padding">{'Write daily gratitude lists'}
          </h4>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'As a part of your daily routine, take 2-5 minutes to make a list of all that you are grateful for. Even in these uncertain times, there is always good to be found. What’s wrong is always available, but so is what’s right. If you take just a couple of minutes each day to find the good, you will develop an incredible habit that will transform your life. Being able to find the good when life is nuttier than squirrel shit is an invaluable skill that\'s developed with consistent daily practice.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <h4 className="tiny-padding">{'Do nothing'}
          </h4>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Life is all about balance and it’s important to remember that sometimes it’s okay to just chill out on your couch with your hand in your pants like Al Bundy. Pausing long enough to tempt boredom can have tremendous value because it gives our mind an opportunity to be free from near-constant distraction. When that happens, creativity and imagination creep out of the dark, dank recesses of your mind and you create a space for magic to happen.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <h4 className="tiny-padding">{'Put yourself on timeouts'}
          </h4>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'There seems to be a direct correlation between the number of days in quarantine and the deterioration of your patience. If you start to notice that you want to back-fist your significant other in the throat every time they speak, it may be a good idea to put yourself on timeout. Before you say or do something you might regret, excuse yourself to another room or go on a walk. Breathing is your friend here. Listen to an uplifting song as you take deep breaths and start to actively focus on memories of that person that you cherish and what you are grateful for about them.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'It all comes down to managing your mindset. Remember that you and your fellow quarantine buddies are part of a partnership. Take responsibility for your thoughts and actions and you will help prevent a massive spike in divorce and breakup rates in the near future.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Novel coronavirus has landed us in uncharted territory, and it feels like there is an underlying anxious energy in the air right now. Often times, fear is expressed as anger, so try to be compassionately aware of the true emotion underneath any frustrated outburst. Own it, apologize, learn from it, then let it go.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'In life, every moment is an opportunity to either choose love or choose fear. Both options are always available, but one makes all the difference. Choose love by finding the good and feeling gratitude, even (especially) as we face this pandemic together.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Hoping you all are safe, sane, and able to find the good. '}
          </p>
        </ScrollFadeIn>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/blogDetail/covidcabinfever.js